import { mapActions } from 'vuex';

export default {
  data() {
    return {
      hasMore: true,
      perPage: 10,
      filters: {},
      campaignList: [],
      campaignsCursor: null,
      isLoading: false,
      filtersData: {
        categories: [],
        statuses: [
          this.$config.statuses.get(0),
          this.$config.statuses.get(2)
        ].map(el => {
          return {
            name: this.$filters.capitalize(this.$t(`statuses.${el}`)),
            id: el
          };
        }),
        taskTypes: [],
        tokenStandards: [],
        managers: []
      }
    };
  },

  computed: {
    isMobileLayout() {
      return (
        this.$root.screen.lg ||
        this.$root.screen.md ||
        this.$root.screen.sm ||
        this.$root.screen.xs
      );
    }
  },

  methods: {
    loadMore() {
      if (this.isLoading || !this.hasMore) return;
      if (this.campaignsCursor === false) {
        this.hasMore = false;
        return;
      }
      this.isLoading = true;
      if (this.$route.query.manager) {
        let managerId = parseInt(this.$route.query.manager, 10);
        this.filters['filter[m]'] = [];
        this.filters['filter[m]'].push(managerId);
      }
      this.$store
        .dispatch('bounty/fetchCampaigns', {
          limit: this.perPage,
          ...this.filters,
          ...(this.campaignsCursor && { cursor: this.campaignsCursor })
        })
        .then(res => {
          this.isLoading = false;
          this.hasMore = res.data.list.length < this.perPage ? false : true;
          this.campaignList = [...this.campaignList, ...res.data.list];
          this.campaignsCursor = res.metadata ? res.metadata.next : false;
        })
        .catch(e => {
          this.isLoading = false;
          if (this.campaignList.length === 0) {
            this.hasMore = false;
            this.$store.commit('SET_PAGE_FAILURE', e);
          }
        });
    },
    updateFilters(filters) {
      this.hasMore = true;
      this.campaignsCursor = null;
      this.campaignList = [];
      this.filters = filters;

      this.loadMore();
    },
    ...mapActions({
      fetchCategories: 'bounty/fetchCategories',
      fetchTokenStandards: 'bounty/fetchTokenStandards',
      fetchTaskTypes: 'bounty/fetchTaskTypes',
      fetchManagers: 'bounty/fetchManagers'
    })
  },

  created() {
    this.fetchCategories()
      .then(res => {
        this.filtersData.categories = res;
      })
      .catch(e => e);
    this.fetchManagers()
      .then(res => {
        this.filtersData.managers = res;
      })
      .catch(e => e);
    this.fetchTokenStandards()
      .then(res => {
        this.filtersData.coinTypes = res;
      })
      .catch(e => e);
    this.fetchTaskTypes()
      .then(res => {
        this.filtersData.taskTypes = res.map(el => {
          return {
            id: el.id,
            name: el.title
          };
        });
      })
      .catch(e => e);

    if (!this.campaignList) this.loadMore();
  }
};
